<div class="vault-doc-container" [class.disabled]="disabled">
  
  <!-- Trigger row -->
  <div class="vault-doc-trigger" [class.edit-mode]="editMode()" [class.open]="isOpen" (click)="toggleDropdown()">
    <span class="doc-selected">
      @if (currentDocuments.length > 0) {
        {{ currentDocuments[0].filename }}
      } @else {
        <span class="doc-placeholder">No documents</span>
      }
    </span>
    <span class="doc-arrow" [class.open]="isOpen"></span>
  </div>

  <!-- Dropdown panel -->
  @if (isOpen) {
    <div class="vault-doc-dropdown">
      @for (doc of currentDocuments; track doc.id) {
        <div class="vault-doc-option" (click)="viewDocument(doc)">
          <span class="doc-name">{{ doc.filename }}</span>
          @if (editMode()) {
            <button
              type="button"
              class="doc-remove-btn"
              title="Remove"
              (click)="removeDocument(doc, $event)"
            >✕</button>
          }
        </div>
      }
      @if (editMode()) {
        <div class="vault-doc-option vault-doc-add" (click)="uploadDocument()">
          <span class="doc-name">Upload document…</span>
        </div>
      }
    </div>
  }

</div>